<template>
    <v-container>
        <v-layout>
            <v-flex xs12 sm12 md12 lg12 xl12>
                <v-card>
                    <v-card-text>
                        <v-form>
                            <v-layout>
                                <v-flex style="font-size: 40px;color:#3b5998;border-bottom: 1px solid #3b5998;">
                                    {{exercise.name}}
                                    <v-btn flat color="primary" @click="editQuestion" style="float: right">
                                        <v-icon>edit</v-icon>
                                        Chỉnh sửa
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm6 md6 lg6 xl6>
                                    <label class="label">{{$t('lang.exercise.dueDate')}}:</label>
                                    {{exercise.dueDate | formatDate}}
                                </v-flex>
                                <!--v-flex xs12 sm6 md6 lg6 xl6>
                                    <label class="label">{{$t('lang.exercise.effectiveDate')}}:</label>
                                    {{exercise.effectiveDate | formatDate}}
                                </v-flex-->
                            </v-layout>
                            <!--v-layout>
                                <v-flex xs12 sm6 md6 lg6 xl6>
                                    <label class="label">{{$t('lang.exercise.subject')}}:</label>
                                    {{exercise.subject}}
                                </v-flex>
                                <v-flex xs12 sm6 md6 lg6 xl6>
                                    <label class="label">{{$t('lang.exercise.markScale')}}:</label>
                                    {{exercise.markScale}}
                                </v-flex>
                            </v-layout-->
                            <v-layout>
                                <v-flex xs12 sm6 md6 lg6 xl6>
                                    <label class="label">{{$t('lang.exercise.questionTime')}}:</label>
                                    {{exercise.questionTime}}
                                </v-flex>
                                <v-flex xs12 sm6 md6 lg6 xl6 v-if="objectType == 6">
                                    <label class="label">{{$t('lang.exercise.numberOfQuiz')}}:</label>
                                    {{exercise.numberOfQuiz}}
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm12 md12lg12 xl12 style="border-top: 1px solid #3b5998;">
                                    <v-tabs background-color="transparent" v-model="selectedTab">
                                        <v-tab :key="1" @click="reloadStudentAnswer">
                                            Chấm bài tập
                                        </v-tab>
                                        <!--v-tab key="studentResult">
                                            {{$t('lang.exercise.result')}}
                                        </v-tab-->
                                        <v-tab :key="2" @click="reloadReport">
                                            Báo cáo sau bài tập
                                        </v-tab>
                                        <v-tabs-items :touchless="true">
                                            <v-tab-item :key="1">
                                                <answer-of-student :class-id="classId"
                                                                   :exercise-id="question.questionId"
                                                                   ref="answerOfStudent"
                                                                   :exercise-type="objectType" :exercise="question"
                                                                   @toReport="activeReport"
                                                                   @showBackBtn="showBackBtn"/>
                                                <v-card-actions style="align-items:flex-end">
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="error" @click="cancel" v-if="showButton">
                                                        <v-icon dark left>keyboard_arrow_left</v-icon>
                                                        {{ $t('lang.common.back') }}
                                                    </v-btn>
                                                    <!--div v-if="showButton">
                                                        <a href="/template/result.xlsx">File template kết quả</a>
                                                        <i-upload class="yoprimary" style="margin-left: 5px"
                                                                  :label="$t('lang.exercise.uploadResultFile')"
                                                                  accept=".xlsx"
                                                                  input-type="button"
                                                                  name="uploadAnswer"
                                                                  :display-result="false"
                                                                  v-model="uploadAnswer"
                                                        />
                                                    </div-->
                                                </v-card-actions>
                                            </v-tab-item>
                                            <!--v-tab-item key="studentResult">
                                                <answer-analysis :class-id="classId" :exercise-id="question.questionId"
                                                                 ref="answerAnalysis"
                                                                 :exercise-type="objectType" :exercise="question"/>

                                            </v-tab-item-->
                                            <v-tab-item :key="2">
                                                <!--answer-report :class-id="classId" :exercise-id="question.questionId"
                                                               ref="answerReport"
                                                               :exercise-type="objectType" :exercise="question"/-->
                                                <lesson-report-item :class-id="classId"
                                                                    :exercise-id="question.questionId"
                                                                    :exercise-type="objectType" ref="studentReport"
                                                                    @close="cancel"/>
                                            </v-tab-item>
                                        </v-tabs-items>
                                    </v-tabs>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {message} from '../../services';
    import IDatepicker from "../../components/form/DatePicker";
    import axios from "axios"
    import IUpload from "../../components/form/Upload";
    import AnswerOfStudent from "./teacher/answerOfStudent";
    import AnswerAnalysis from "./teacher/answerAnalysis";
    import AnswerReport from "./teacher/answerReport";
    import LessonReportItem from "./report/lessonReportItem";

    export default {
        name: "teacher-view-question",
        components: {
            LessonReportItem,
            AnswerReport,
            AnswerAnalysis,
            AnswerOfStudent,
            IUpload,
            IDatepicker,
        },

        props: {
            classId: {
                type: String | Number,
                default: () => {
                    return null;
                }
            },
            objectType: {
                type: String | Number,
                default: () => {
                    return null;
                }
            },

            studentId: {
                type: String | Number,
                default: () => {
                    return null;
                }

            },

            question: {
                type: Object,
                default: () => {
                    return null;
                }
            }

        },
        data() {
            return {
                selectedTab: 0,
                clazz: {},
                uploadAnswer: null,
                accept: ".pdf, .doc, .docx, image/*",
                exercise: {
                    "name": "",
                    "subject": "",
                    "dueDate": new Date(),
                    "effectiveDate": new Date(),
                    "markScale": 10,
                    "content": "",

                },
                showButton: true,
                subjects: [],
                grades: []
            }
        },

        created() {
            if (this.question != null) {
                this.exercise.questionId = this.question.questionId;
                this.exercise.name = this.question.name;
                this.exercise.subject = this.question.subject;
                this.exercise.dueDate = this.question.dueDate;
                this.exercise.effectiveDate = this.question.effectiveDate;
                this.exercise.markScale = this.question.markScale;
                this.exercise.content = this.question.content;
                this.exercise.attachId = this.question.attachId;
                this.exercise.questionTime = this.question.questionTime;
                this.exercise.numberOfQuiz = this.question.numberOfQuiz;
            }
        },

        watch: {
            uploadAnswer: function (data) {
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                        "/exercise/uploadFileResult?attachId=" +
                        data + "&exerciseId=" + this.question.questionId + "&exerciseType=" + this.objectType
                    )
                    .then(
                        data => {
                            if (data.success) {
                                message.success(this.$t('lang.common.uploadSuccess'));
                                this.refreshPage();
                            } else {
                                message.error(this.$t(data.message));
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    );
            }

        },
        mounted() {
            if (this.studentId != undefined && this.studentId != null && this.studentId != "") {
                this.viewUserExercise(this.studentId);
            }

        },

        methods: {
            reloadStudentAnswer() {
                this.$refs.answerOfStudent.init();
            },

            reloadReport() {
                this.$refs.studentReport.getReport();
            },

            editQuestion() {
                this.$emit("onEditQuestion", this.question);
            },

            refreshPage: function () {
                this.$refs.answerOfStudent.init();
                //this.$refs.answerAnalysis.init();
                //this.$refs.answerReport.getReports();
            },

            showBackBtn: function (show) {
                this.showButton = show;
                if (show) {
                    this.refreshPage();
                }
            },

            viewUserExercise: function (userId) {
                this.$refs.answerOfStudent.viewStudentAnswer(userId);
            },

            cancel: function () {
                this.$emit("onCancelCreate");
            },

            activeReport() {
                //console.log("active report");
                this.selectedTab = 1;
                this.$nextTick(
                    () => {
                        //console.log("come to next tick");
                        this.$refs.studentReport.edit();
                    }
                )
            }
        }
    };
</script>

